export default __webpack_public_path__ + "static/media/mc_settings_button_icon.d2c15dca.svg";